import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'
import t from '~/scopes/campaign/data/metals/tungsten.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['ademe2024'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['ademe2024'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['usgsMcs2025', 'ieaMineralsExplorer'],
  },
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
      },
      blocks: [],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['ademe2024', 'pblSocial2025', 'euCrma2024'],
      },
      blocks: [
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['ademe2024', 'pblSocial2025', 'euCrma2024'],
        },
        {
          title: SECTIONS.humanChildLabour,
          text: t.humanChildLabourText,
          sourceRefs: ['ademe2024', 'pblSocial2025', 'euCrma2024'],
        },
        {
          title: SECTIONS.humanGender,
          text: t.humanGenderText,
          sourceRefs: ['ademe2024', 'pblSocial2025', 'euCrma2024'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'ademe2024', 'ieaGcmo2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['ademe2024', 'ieaRecycling2024'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['ieaGcmo2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['ieaGcmo2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['greenIt'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['ademe2024'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['jrcCircular2017'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['jrcCircular2017', 'ademe2024'],
      },
    ],
  },
  mine0Region: t.mine0Region,
  mine1Region: t.mine1Region,
  mine2Region: t.mine2Region,
  mine3Region: t.mine3Region,
  mine4Region: t.mine4Region,
} as const
